


import Vue from 'vue';
import {RouteName} from "@/router";
import $ from "jquery";

const breakpoint = 767;

window.addEventListener('scroll', () => {
    const scroll = $(window).scrollTop() || 0;
    const pageHeight = $(document).outerHeight(true) as number;
    const windowHeight = window.outerHeight;
    const footerHeight = 110;
    if (scroll >= 200 && scroll <= (pageHeight - windowHeight - footerHeight)) {
        $(".sticky-offer-link").fadeIn(500);
    } else {
        $(".sticky-offer-link").fadeOut(500);
    }
}, {passive: true});

export default Vue.extend({
    data: () => ({
        isMobile: false,
        offerLocation: {name: RouteName.offerList},
    }),
    created(): void {
        this.calculateIsMobile();
        window.addEventListener('resize', this.calculateIsMobile, {passive: true});
    },
    computed: {
        shouldShow(): boolean {
            return !this.$route.meta.currentOffer && this.isMobile;
        }
    },
    methods: {
        calculateIsMobile() {
            this.isMobile = window.innerWidth < breakpoint;
        }
    }
});
